export { default } from './Lottie';